import { useclientsdetails } from "@/hooks/useManageClients";
import { Box, styled } from "@mui/material";
import Image from "next/image";
import React from "react";

//styled
const ProjectDetailsCardBox = styled(Box)`
  .projectBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 0px 12px rgba(52, 84, 207, 0.08);
    border-radius: 6px;
    padding: 10px 16px;
    background: #fff;
    .projectBoxTxt {
      p {
        font-weight: 400;
        font-size: 16px;
        line-height: 1.1;
        text-align: left;
        color: #121d32;
        margin: 0 0 4px;
        @media (max-width: 1399px) {
          font-size: 14px;
          min-height: 40px;
        }
        @media (max-width: 1199px) {
          min-height: auto;
        }
      }
      h4 {
        font-weight: 600;
        font-size: 24px;
        line-height: 1.1;
        color: #121d32;
        margin-bottom: 4px;
        @media (max-width: 1199px) {
          font-size: 16px;
        }
      }
    }
    .projectBoxImg {
      width: 47px;
      height: 47px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

interface itemInterface {
  item: {
    textp: string;
    // textg4: string;
    counts: number;
    img: string;
    textg4:string
  };
  // index: number;
  //   id: any;
}

const ProjectDetailsCard = (props: itemInterface) => {
  const { item } = props;
  //   const id = props.id;
  //   const { data: productdetails } = useclientsdetails(id);
  //   console.log("Project details-->", productdetails);
  console.log(item,">>>>>")

  return (
    <ProjectDetailsCardBox>
      <Box className="projectBox">
        <Box className="projectBoxTxt">
          <p>{item.textp}</p>
          {/* <h4>{item.textg4}</h4> */}
          <h4 style={{ marginTop: 10 }}>{item.counts || item?.textg4 ||  0}</h4>
        </Box>

        <Box className="projectBoxImg">
          <Image src={item.img} width={27} height={23} alt="" />
        </Box>
      </Box>
    </ProjectDetailsCardBox>
  );
};

export default ProjectDetailsCard;
